export const completeServerUrl = (envServerUrl) => {
  let rtnUrl = envServerUrl;
  if (envServerUrl.startsWith('/')) {
    // API서버의 도메인이 Frontend 서버 URL과 동일한 경우

    rtnUrl = window.location.origin + envServerUrl;
    if (window.location.origin.endsWith('/')) {
      rtnUrl = window.location.origin + envServerUrl.substring(1);
    }
  }

  if (rtnUrl.endsWith('/')) {
    return rtnUrl.substring(0, rtnUrl.length - 1);
  }
  return rtnUrl;
};


export const parseDotnetAPIUrl = (url) => {
  // url은 /E3/SYS/SYS125 와 같은 형태
  let programId, methodName;

  const elements = url.split('/');
  if (elements && elements.length === 4) {
    programId = elements[2];
    methodName = elements[3];
  }  
  return { programId, methodName };
};
